import { Link } from "react-router-dom";
import { cn } from "../../lib/cn";

type BrandProps = {
  compact?: boolean;
  inverse?: boolean;
  className?: string;
  target?: "_blank" | "_self";
};

export function Brand({ compact = false, inverse = false, className, target = "_self" }: BrandProps) {
  const source = compact
    ? "/brand/logo-mark-exact.png"
    : "/brand/logo-horizontal-exact.png";

  return (
    <Link
      to="/"
      target={target}
      rel={target === "_blank" ? "noopener noreferrer" : undefined}
      className={cn(
        "inline-flex shrink-0 items-center",
        inverse && !compact && "rounded-2xl bg-white px-3 py-2 shadow-sm",
        className,
      )}
      aria-label="CSJW — Chat Sekali, Jadi Website"
    >
      <img
        src={source}
        alt="CSJW — Chat Sekali, Jadi Website"
        className={cn(
          "block select-none object-contain",
          compact ? "h-12 w-12 rounded-2xl" : "h-12 w-auto max-w-[250px]",
        )}
        draggable={false}
      />
    </Link>
  );
}
